import React, {Component} from 'react';
import scrollToComponent from 'react-scroll-to-component';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import JunkSizeMailService from '../services/JunkSizeMailService';


class Size extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;

        this.JunkSizeMailService = new JunkSizeMailService();

        this.state = {
            diffModal: false,
            type: this.localState.type || '',
            extras: this.localState.extras,
            selected_extras: this.localState.selected_extras,
            modal: false,
            photoModal: false,
            fileNames: [],
            filesForUpload: [],
            first_name: '',
            last_name: '',
            email: '',
            filesError: false,
            filesErrorMessage: '',
            mailSuccess: false,
            mailSuccessMessage: '',
            mailError: false,
            mailErrorMessage: '',
            errorResponse: null,
            variation: this.props.variation
        };

        this.handleSelectType = this.handleSelectType.bind(this);
        this.handleSelectExtraQty = this.handleSelectExtraQty.bind(this);
        this.submitStep = this.submitStep.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.changeVariation = this.changeVariation.bind(this);
        // this.togglePhotoModal = this.togglePhotoModal.bind(this);
        // this.handleInputFileClick = this.handleInputFileClick.bind(this);
        // this.handleSelectedFileNames = this.handleSelectedFileNames.bind(this);
        // this.submitFormData = this.submitFormData.bind(this);
        // this.handleFilesUpload = this.handleFilesUpload.bind(this);

        this.props.variation == 'man_and_van'
            ? ga('set', 'page', '/wizard/man-and-van/step-2/extras-select')
            : ga('set', 'page', '/wizard/skip/step-2/extras-select');

        ga('send', 'pageview');
    }

    // componentDidMount() {
    //     this.props.modal();
    // }

    componentDidUpdate(oldProps) {
        const newProps = this.props;
        if (oldProps.variation !== newProps.variation) {
            this.setState({
                variation: newProps.variation
            })
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    toggleConfirmation() {
        this.setState({
            diffModal: !this.state.diffModal
        });
    }

    changeVariation() {
        this.props.changeVariation();
        this.toggleConfirmation();
    }

    // togglePhotoModal() {
    //     this.setState({
    //         first_name: '',
    //         last_name: '',
    //         email: '',
    //         fileNames: [],
    //         errorResponse: null,
    //         photoModal: !this.state.photoModal
    //     }, () => {
    //         this.inputFile.value = null
    //     });
    // }

    handleSelectType(type) {
        this.setState({
            type: type
        }, () => {
            scrollToComponent(this.ExtrasQty, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            this.localState.type = type;
            this.props.setValidity(true);
        });
    }

    handleSelectExtraQty(event, extra) {
        let extras = [...this.state.extras];
        let selected_extras = [...this.state.selected_extras];

        let updateable = extras.find((item) => item.id === extra.id);

        let selected = selected_extras.find((item) => item.id === extra.id);

        if (!selected) {
            selected_extras.push({
                ...updateable,
                total_price: event.target.value * updateable.price_per_item,
                qty: event.target.value
            });
        }

        if (selected) {
            let index = selected_extras.indexOf(selected);
            selected_extras.splice(index, 1);

            if (event.target.value != '0') {
                selected_extras.push({
                    ...selected,
                    total_price: event.target.value * selected.price_per_item,
                    qty: event.target.value
                });
            }
        }

        this.setState({
            extras: extras,
            selected_extras: selected_extras
        }, () => {
            this.localState.extras = this.state.extras;
            this.localState.selected_extras = this.state.selected_extras;
            this.props.globalStateChange(this.localState);
            this.props.updatePrice();
        });
    }

    displayTotal(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.total_price;
        } else {
            return '0';
        }
    }

    checkDefaultValue(extra) {
        let selected_extras = [...this.state.selected_extras];
        let updateable = selected_extras.find((item) => item.id === extra.id);

        if (updateable) {
            return updateable.qty;
        } else {
            return '';
        }
    }

    submitStep() {
        this.localState.selected_extras = this.state.selected_extras;
        this.props.globalStateChange(this.localState);
        this.props.nextStep();
    }


    render() {
        // if(this.state.errorResponse)
        //     console.log(this.state.errorResponse["images.0"]);
        return (
            <div className='container pb-5'>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="alert alert-dark text-center">
                            <p style={{marginBottom: '0'}}>Please note we cannot take <span className='prohibited-items' onClick={this.toggle}><u>prohibited items</u></span>.
                            </p>
                        </div>
                    </div>
                </div>
                {this.props.variation == 'skip' &&
                <div className="row justify-content-center pb-3">
                    <div className="col-md-6">
                        <div className="alert text-center" style={{background: '#FDB913'}}>
                            <p style={{marginBottom: '0', color: '#ffffff'}}>
                                Please note that as standard our skip hire period is 2 weeks. An additional charge will apply if longer required. Please contact the office for more information.
                            </p>
                        </div>
                    </div>
                </div>
                }
                <div className="row justify-content-center pb-3">
                    <h2 className="wizard-heading pt-sm-0 pt-5">Any extras?</h2>
                </div>
                <section className='ExtrasQty' ref={(section) => {
                    this.ExtrasQty = section;
                }}>
                    {/*<div className="row justify-content-center py-4">*/}
                    {/*<h2 className="wizard-heading">Any Extras?</h2>*/}
                    {/*</div>*/}
                    {this.state.variation == 'man_and_van' &&
                    this.localState.extras.map((extra, index) => {
                        return (
                            <div className="row justify-content-center my-1" key={extra.id}>
                                <div className="col-md-10">
                                    <div className="card">
                                        <div className="card-body card-wizard">
                                            <div className='row'>
                                                <div className='col-md-2 col-6 order-2 order-md-1'>
                                                    <select name={extra.name} defaultValue={this.checkDefaultValue(extra)}
                                                            className='form-control'
                                                            onChange={(event) => this.handleSelectExtraQty(event, extra)}>
                                                        {Array(extra.max_quantity + 1).fill().map((index, number) => {
                                                            return (
                                                                <option key={number}
                                                                    // value={number*extra.price_per_item}
                                                                        value={number}
                                                                >{number}</option>
                                                            )
                                                        })};
                                                    </select>
                                                </div>
                                                <div
                                                    className='col-md-8 d-flex align-items-center order-1 order-md-2 mb-2'>
                                                    <p style={{marginBottom: '0', color: '#FDB913'}}>{extra.name}</p>
                                                </div>
                                                <div className='col-md-2 col-6 order-3 order-md-3'>
                                                    <div style={{
                                                        border: '1px solid rgba(0,0,0,.125)',
                                                        borderRadius: '4px',
                                                        padding: '.375rem .75rem',
                                                        backgroundColor: '#fff'
                                                    }}>
                                                        &#163;<span>
                                                        {/*{this.state.extras[index].total_price || '0'} */}
                                                        {this.displayTotal(extra)}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    {this.state.variation == 'skip' &&
                    <div className='row justify-content-center'>
                        <div className="col-md-10">
                            <p>If you have any of the following items, please note they cannot be disposed of in a skip and the skip collection may not be completed.</p>
                            <ul className='pl-md-5 pl-sm-3'>
                                {this.localState.extras.map((extra, index) => {
                                    return <li key={index}>{extra.name}</li>
                                })}
                            </ul>
                            <p>
                                However, we can collect waste that may contain the above items on our Man & Van waste collection service, which is environmentally friendly and generally more cost effective.
                                <span className='prohibited-items' onClick={this.toggleConfirmation}> <u>Click here</u></span> to switch to our Man & Van service.
                            </p>
                            {/*<div className="alert alert-dark">*/}
                            {/*<p className='pb-2'>If you have any of the below items, please use our Man and Van service as these cannot be put in skips...</p>*/}
                            {/*{this.localState.extras.map((extra, index) => {*/}
                            {/*return <p className='text-center' key={index}>{extra.name}</p>*/}
                            {/*})}*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    }

                    <div className="row justify-content-center mt-5">
                        <button className="btn btn-round btn-cw btn-back py-3 mx-2" onClick={this.props.prevStep}>Back
                        </button>
                        <button className="btn btn-round btn-cw btn-next btn-yellow py-3 mx-2"
                                onClick={this.submitStep}>Next
                        </button>
                    </div>
                </section>


                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>Prohibited items</ModalHeader>
                    <ModalBody>
                        <div className="container text-left">
                            <p>Unfortunately we are unable to collect any of the following items, for health & safety and regulatory reasons:</p>
                            <ul>
                                <li>Any fridge, freezer or commercial units</li>
                                <li>Asbestos</li>
                                <li>Batteries</li>
                                <li>Biological or Medical waste</li>
                                <li>Box style CRT television(s) or monitor(s).</li>
                                <li>Chemicals (including toxic substances, noxious chemicals & solvents)</li>
                                <li>Gas bottles</li>
                                <li>Fire extinguisher</li>
                                <li>Fuels (Petrol, Diesel & Oil)</li>
                                <li>Mattresses</li>
                                <li>Paint tins (full or empty)</li>
                                <li>Pianos</li>
                                <li>Raw meat or raw fish (unless packaged)</li>
                                <li>Rubble or soil (due to weight)</li>
                                {this.props.variation == 'skip' &&
                                <React.Fragment>
                                    <li>TVs or monitors (all types)</li>
                                    <li>Tyres</li>
                                </React.Fragment>
                                }
                                <li>Unbagged domestic refuse</li>
                            </ul>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-round py-3 btn-cw btn-yellow' onClick={this.toggle}>Continue</button>
                    </ModalFooter>
                </Modal>

                {this.props.variation == 'skip' &&
                <Modal isOpen={this.state.diffModal} toggle={this.toggleConfirmation} className='modal-dialog modal-lg'>
                    <ModalHeader toggle={this.toggleConfirmation}>Are you sure?</ModalHeader>
                    <ModalBody>
                        <p>You are about to change your current order to hire a <b>{this.props.size.size.size_uk}</b> skip to the equivalent Man & Van waste collection option, which is <b>{this.props.size.size.relative.size_uk} CY</b>.</p>
                        <p>Currently this will save you <b>&#163;{(this.props.size.size.price - this.props.size.size.relative.price) / 100}</b>.</p>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-round py-3 btn-cw btn-back' onClick={this.toggleConfirmation}>Cancel</button>
                        <button className='btn btn-round py-3 btn-cw btn-yellow' onClick={this.changeVariation}>Continue</button>
                    </ModalFooter>
                </Modal>
                }
            </div>
        );
    }
}

export default Size;

